import script from "./addProduitsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./addProduitsView.vue?vue&type=script&setup=true&lang=ts"

import "./addProduitsView.vue?vue&type=style&index=0&id=175236ed&scoped=true&lang=scss"
import "./addProduitsView.vue?vue&type=style&index=1&id=175236ed&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175236ed"]])

export default __exports__